import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import { pickState } from '../_core/pickState';
import useAnalyticStore from '../analyticStore/useAnalyticStore';
import useApiStore from '../apiStore/useApiStore';
import useDashboardStore from '../dashboardStore/useDashboardStore';
import useParameterStore from '../parameterStore/useParameterStore';
import useWorkflowStore from '../workflowStore/useWorkflowStore';
import { applyStore, keysToPersist } from './applyStore';

const useApplyStore = createStore({
  creator: applyStore({
    useAnalyticStore: lazyDependency(() => useAnalyticStore),
    useApiStore: lazyDependency(() => useApiStore),
    useDashboardStore: lazyDependency(() => useDashboardStore),
    useParameterStore: lazyDependency(() => useParameterStore),
    useWorkflowStore: lazyDependency(() => useWorkflowStore),
  }),
  id: 'apply',
  middlewares: {
    devtools: true,
    persist: {
      partialize: (state) => pickState(state, keysToPersist),
    },
  },
});

export default useApplyStore;
